import { React } from 'react'
import {  GoogleAuthProvider,  getAuth,  signInWithPopup,  signInWithEmailAndPassword,  createUserWithEmailAndPassword,
     sendPasswordResetEmail, updateProfile ,  signOut, updateCurrentUser, FacebookAuthProvider, TwitterAuthProvider} from "firebase/auth";
import {  getFirestore,  query,  getDocs,  collection, where, addDoc } from 'firebase/firestore'
import { initializeApp } from "firebase/app";
import { getStorage, } from "firebase/storage";
import { getDatabase, ref, set } from "firebase/database";
import '../.env'


const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASEAPI,
    authDomain: process.env.REACT_APP_FIREBASEDOMAIN,
    projectId: process.env.REACT_APP_FIREBASEPROJECTID,
    storageBucket: process.env.REACT_APP_FIREBASESTORAGEBUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASEMESSAGE,
    appId: process.env.REACT_APP_FIREBASEAPPID,
    measurementId: process.env.REACT_APP_FIREBASEMEASURMENTID,
    databaseURL: process.env.REACT_APP_FIREBASEDATABASE
    // No Secret
};


const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);
const database = getDatabase(app);

const googleProvider = new GoogleAuthProvider();
const facebookProvider = new FacebookAuthProvider();
const twitterProvider = new TwitterAuthProvider();
const signInWithGoogle = async () => {
  try {
    const res = await signInWithPopup(auth, googleProvider);
    const user = res.user;
    const q = query(collection(db, "users"), where("uid", "==", user.uid));
    const docs = await getDocs(q);
    if (docs.docs.length === 0) {
      await addDoc(collection(db, "users"), {
        uid: user.uid,
        name: user.displayName,
        authProvider: "google",
        email: user.email,
      });
    }
  } catch (err) {
    console.error(err);
    alert(err.message);
  }
};
const signInWithFacebook = async () => {
    signInWithPopup(auth, facebookProvider)
  .then((result) => {
    // The signed-in user info.
    const user = result.user;

    // This gives you a Facebook Access Token. You can use it to access the Facebook API.
    const credential = FacebookAuthProvider.credentialFromResult(result);
    const accessToken = credential.accessToken;

    // IdP data available using getAdditionalUserInfo(result)
    // ...
  })
  .catch((error) => {
    // Handle Errors here.
    const errorCode = error.code;
    const errorMessage = error.message;
    // The email of the user's account used.
    const email = error.customData.email;
    // The AuthCredential type that was used.
    const credential = FacebookAuthProvider.credentialFromError(error);

    // ...
  });
  };
const signInWithTwitter = async () => {
  try {
    const res = await signInWithPopup(auth, twitterProvider);
    const user = res.user;
    const q = query(collection(db, "users"), where("uid", "==", user.uid));
    const docs = await getDocs(q);
    if (docs.docs.length === 0) {
      await addDoc(collection(db, "users"), {
        uid: user.uid,
        name: user.displayName,
        authProvider: "twitter",
        email: user.email,
      });
    }
  } catch (err) {
    console.error(err);
    alert(err.message);
  }
};

const logInWithEmailAndPassword = async (email, password) => {
    try {
      await signInWithEmailAndPassword(auth, email, password);
    } catch (err) {
      console.error(err);
      alert(err.message);
    }
  };

  const registerWithEmailAndPassword = async (name, email, password) => {
    try {
      const res = await createUserWithEmailAndPassword(auth, email, password)
      .then( async (res)=>{
        await updateProfile( auth.currentUser ,{displayName: name})
      }).catch((err)=>{console.log(err)})
    } catch (err) {
      console.error(err);
      alert(err.message);
    }
  };

  const sendPasswordReset = async (email) => {
    try {
      await sendPasswordResetEmail(auth, email);
      alert("Password reset link sent to your email!");
    } catch (err) {
      console.error(err);
      alert(err.message);
    }
  };

  const logout = () => {
    signOut(auth);
  };

  function writeUserData(userId, name, phone, address) {
    const db = getDatabase();
    set(ref(db, 'users/' + userId), {
      Id: userId, 
      Name: name,
      phone: phone,
      address: address
    });
  }



  export {
    auth,
    db,
    signInWithGoogle,
    logInWithEmailAndPassword,
    registerWithEmailAndPassword,
    sendPasswordReset,
    logout,
    signInWithFacebook,
    signInWithTwitter,
    writeUserData
  };
